import React from "react";
import Attachments from "../BasicInfo/Attachments";
import PropTypes from "prop-types";

const InsuranceAttachments = ({ attachments, onAttachmentsUpdated }) => (
  <Attachments
    attachments={attachments}
    type={"insurance"}
    onAttachmentsUpdated={onAttachmentsUpdated}
  />
);

InsuranceAttachments.propTypes = {
  attachments: PropTypes.array,
  onAttachmentsUpdated: PropTypes.func,
};

export default InsuranceAttachments;
